import '@/locales/i18n';
import ThemeProvider from '@/theme';
import Router from '@/routes/sections';
import 'simplebar-react/dist/simplebar.min.css';
import { LocalizationProvider } from '@/locales';
import ProgressBar from '@/components/feedback/progress-bar';
import { SnackbarProvider } from '@/components/feedback/snackbar';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { MotionLazy } from '@/components/utils/animate/motion-lazy';
import { AuthConsumer, AuthProvider } from '@/auth/context/jwt';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { QueryClientProvider } from '@tanstack/react-query';
import { enableCache } from '@iconify/react';
import { ErrorBoundary } from '@/components/utils/errors';
import { SettingsDrawer, SettingsProvider } from './components/layout/settings';
import { createQueryClient } from './providers';

// Enable cache for Iconify
enableCache('local');

const queryClient = createQueryClient();

export default function App() {
  return (
    <ErrorBoundary showDetails={import.meta.env.DEV}>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <LocalizationProvider>
            <SettingsProvider
              defaultSettings={{
                themeMode: 'light', // 'light' | 'dark'
                themeDirection: 'ltr', //  'rtl' | 'ltr'
                themeContrast: 'default', // 'default' | 'bold'
                themeLayout: 'vertical', // 'vertical' | 'horizontal' | 'mini'
                themeColorPresets: 'default', // 'default' | 'cyan' | 'purple' | 'blue' | 'orange' | 'red'
                themeStretch: true,
              }}
            >
              <ThemeProvider>
                <MotionLazy>
                  <SnackbarProvider>
                    <SettingsDrawer />
                    <ProgressBar />
                    <AuthConsumer>
                      <Router />
                    </AuthConsumer>
                  </SnackbarProvider>
                </MotionLazy>
                <ReactQueryDevtools initialIsOpen={false} />
              </ThemeProvider>
            </SettingsProvider>
          </LocalizationProvider>
        </AuthProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
